import React from 'react';
import DecisionTreeEngine from './DecisionTreeEngine';

/**
 * DynamicTree - Renders an AI-facilitated decision tree
 * Uses the same DecisionTreeEngine as the hand-built trees
 */

const DynamicTree = ({ treeData, onClose }) => {
  // Convert the saved tree format to the format expected by DecisionTreeEngine
  const treeConfig = {
    title: treeData.title,
    subtitle: treeData.subtitle || `AI-FACILITATED SESSION`
  };

  // Gates are already in the correct format from the AI
  const allGates = treeData.gates.map((gate, index) => ({
    id: gate.id || String(index + 1).padStart(2, '0'),
    type: gate.type || 'YES/NO',
    question: gate.question,
    yesLabel: gate.yesLabel,
    noLabel: gate.noLabel,
    noText: gate.noText || 'Return to this gate when ready.',
    inverted: gate.inverted || false
  }));

  // Linear tree: always return full sequence
  const getNextGates = () => allGates;

  // Result from AI
  const getResult = () => ({
    text: treeData.result_text || 'Session complete.'
  });

  return (
    <DecisionTreeEngine
      treeConfig={treeConfig}
      allGates={allGates}
      getNextGates={getNextGates}
      getResult={getResult}
      onClose={onClose}
    />
  );
};

export default DynamicTree;
